import { render } from "./WeekdayAvailability.vue?vue&type=template&id=8edb2280&scoped=true"
import script from "./WeekdayAvailability.vue?vue&type=script&lang=js"
export * from "./WeekdayAvailability.vue?vue&type=script&lang=js"

import "./WeekdayAvailability.vue?vue&type=style&index=0&id=8edb2280&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ccjoe\\Documents\\CC2\\CareControlJobs\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8edb2280"]])

export default __exports__